import React from "react";
import {
  AlertDialog,
  ConfirmDialog,
  InputDialog,
  LoadingDialog,
} from "./alerts";
import { sleep } from "../functions";

let gContext;
function getContext() {
  if (!gContext) gContext = React.createContext({});

  return gContext;
}

export const GlobalContext = getContext();

function showDialog(setDialogConfig, dialog) {
  return function (params, onConfirm, onUnconfirm) {
    setDialogConfig((c) => {
      Object.keys(c).forEach((dlg) => {
        if (c[dlg].open) c[dlg].open = false;
      });
      const d = { ...c[dialog] };
      d.params = { onConfirm, onUnconfirm, ...params };
      d.open = true;
      return {
        ...c,
        [dialog]: d,
      };
    });
  };
}

function hideDialog(setDialogConfig, dialog, delay = 0) {
  async function run() {
    if (delay) await sleep(delay);
    setDialogConfig((c) => {
      const d = { ...c[dialog] };
      d.open = false;
      return {
        ...c,
        [dialog]: d,
      };
    });
  }
  return run;
}

const dialogConfigParams = (getState) => {
  return [
    "loadingDialog",
    "confirmDialog",
    "alertDialog",
    "inputDialog",
  ].reduce((p, c) => {
    const vl = {
      open: false,
      params: {},
      onClose: function () {
        getState()((d) => ({ ...d, [c]: { ...d[c], open: false } }));
      },
    };

    p[c] = vl;
    return p;
  }, {});
};

const Provider = (props) => {
  const [dialogConfig, setDialogConfig] = React.useState(
    dialogConfigParams(function () {
      return setDialogConfig;
    }),
  );

  const { confirmDialog, alertDialog, inputDialog, loadingDialog } =
    dialogConfig;

  return (
    <>
      {React.useMemo(
        () => (
          <GlobalContext.Provider
            value={{
              showConfirmDialog: showDialog(setDialogConfig, "confirmDialog"),
              showAlert: showDialog(setDialogConfig, "alertDialog"),
              showLoading: showDialog(setDialogConfig, "loadingDialog"),
              dismissLoading: hideDialog(setDialogConfig, "loadingDialog", 500),
              showInputDialog: showDialog(setDialogConfig, "inputDialog"),
            }}
          >
            <BackgroundWaterMark>{props.children}</BackgroundWaterMark>
          </GlobalContext.Provider>
        ),
        [],
      )}
      <ConfirmDialog {...props} {...confirmDialog} />
      <LoadingDialog {...props} {...loadingDialog} />
      <AlertDialog {...props} {...alertDialog} />
      <InputDialog {...props} {...inputDialog} />
    </>
  );
};

const BackgroundWaterMark = ({ children }) => {
  return (
    <div
      style={{
        backgroundImage: `url(assets/logo_512.png)`,
        backgroundSize: "30%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        overflow: "auto",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255,255,255, 0.99)", // Black overlay with 50% opacity
          pointerEvents: "none",
        }}
      ></div>
      <div style={{ position: "relative", height: "100vh" }}>{children}</div>
    </div>
  );
};

export default Provider;
